<div class="tab-body-top">
  <h3>Members</h3>
  <div class="job-search">
    <input type="text" [(ngModel)]="term" (keyup.enter)="onSearch(term)" placeholder="Search contact..." />
    <button>
      <svg viewBox="0 0 18 18">
        <use href="#search" />
      </svg>
    </button>
  </div>
</div>
<div class="block">
  <app-loader-2 *ngIf="!members.items; else body"></app-loader-2>
  <ng-template #body>
    <section class="d-flex flex-wrap flex-column flex-md-row members">
      <div class="member-item" *ngFor="let member of members.items">
        <div class="member-logo-wrapper">
          <div class="member-logo">
            <a [profile]="member">
              <app-avatar
                [src]="member.icon | profileImg"
                [placeholder]="member | initials"
                class="img-fluid"
              ></app-avatar>
            </a>
          </div>
        </div>
        <div class="member-content">
          <div class="member-text">
            <div class="member-title">
              <a [profile]="member"> {{ member.name }} </a>
            </div>
            <div class="member-description">{{ member.type_name }}</div>
          </div>
          <div class="member-explore-link" *ngIf="!(member.id | isCurrentUser | async)">
            <!--            <a href="" *ngIf="!(member.is_friend || member.friend_request); else friendBlock"-->
            <!--              (click)="onConnect(member.id); $event.stopPropagation(); false">Connect +</a>-->
            <!--            <ng-template #friendBlock>-->
            <!--              <a href="" (click)="onDisconnect(member.id); $event.stopPropagation(); false">Disconnect</a>-->
            <!--            </ng-template>-->
            <!--            <a href="" *ngIf="(member.is_friend || member.friend_request)"-->
            <!--              (click)="onConnect(member.id); $event.stopPropagation(); false">Disconnect</a>-->
          </div>
        </div>
      </div>
    </section>
    <div class="d-flex justify-content-center justify-content-md-end mt-md-auto mr-md-3 mb-3">
      <app-page-counter
        *ngIf="members.amountOfPages"
        [currentPage]="page"
        [amountOfPages]="members.amountOfPages"
        (setPage)="onSetPage($event)"
        class="mt-md-auto"
      ></app-page-counter>
    </div>
  </ng-template>
</div>
